import {
  registrationSlug,
  type CoupleTrailerInput,
  type CouplingListQuery,
  type FleetUnit,
  type Page,
  type RigListItem,
  type RigListQuery,
  type TruckTrailerCoupling,
  type UncoupleTrailerInput,
} from '@chukua/common';
import { api } from '../../../../shared/shared.api';
import { toListParams } from '../../../../shared/policies/list-params';

/** Fleet → Units: each truck with the trailer it pulls, and the spare trailers (gitaumoses4/chukua#390). */
export function listRigs(query: RigListQuery): Promise<Page<RigListItem>> {
  return api<Page<RigListItem>>(`/rigs?${toListParams(query)}`);
}

/** A truck's or trailer's coupling history, newest first; `current: true` is what is coupled now. */
export function listCouplings(query: CouplingListQuery): Promise<Page<TruckTrailerCoupling>> {
  return api<Page<TruckTrailerCoupling>>(`/couplings?${toListParams(query)}`);
}

/** Couple, or swap: the truck's current trailer is dropped at `dropZoneCode`, and a trailer on another truck moves across. */
export function coupleTrailer(input: CoupleTrailerInput): Promise<TruckTrailerCoupling> {
  return api<TruckTrailerCoupling>('/couplings', { method: 'POST', body: JSON.stringify(input) });
}

export function uncoupleTrailer(couplingId: string, input: UncoupleTrailerInput): Promise<TruckTrailerCoupling> {
  return api<TruckTrailerCoupling>(`/couplings/${couplingId}/uncouple`, { method: 'POST', body: JSON.stringify(input) });
}

/** The unit a registration names: a truck and its trailer, or a spare trailer alone. A coupled trailer's leads to its truck. */
export function getUnit(registration: string): Promise<FleetUnit> {
  return api<FleetUnit>(`/units/${encodeURIComponent(registrationSlug(registration))}`);
}
